import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaRegHeart, FaBagShopping, FaUser, FaTruckFast } from 'react-icons/fa6';
import { useAuth } from '../user/AuthContext';
import { useGlobal } from '../../global/GlobalContext';
import HeaderSearchBar from '../HeaderSearchBar';
import { Heart, User2Icon, UserRound } from 'lucide-react';
import { BiExit } from 'react-icons/bi';
import { GoPackageDependents } from "react-icons/go";
import { FiMenu, FiChevronDown } from 'react-icons/fi';
import MetaData from '../../layout/MetaData';

const shopCategories = [
  { label: 'Planters', to: '/planters' },
  { label: 'Container', to: '/container' },
  { label: 'Bucket', to: '/bucket' },
  { label: 'Mug', to: '/mug' },
  { label: 'Tasla', to: '/tasla' },
  { label: 'Fridge Bottle', to: '/fridge-bottle' },
];

const NavTop = () => {
  const { userToken, logout } = useAuth();
  const [showMenu, setShowMenu] = useState(false);
  const [showCategoryMenu, setShowCategoryMenu] = useState(false);
  const { wishlist, cartLength } = useGlobal();
  const location = useLocation();
  const navLinkClass = (to) =>
    location.pathname === to
      ? 'text-brand-600 border-b-2 border-brand-600 pb-1'
      : 'hover:text-brand-600';

  // const cartCount = cart.length;
  const wishlistCount = wishlist.length;

  useEffect(() => {
    if (showMenu) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  
    return () => {
      document.body.style.overflow = '';
    };
  }, [showMenu]);

  return (
    <>
    <MetaData />
      <header className="z-50 w-full sticky top-0">
        <div className="max-w-7xl mx-auto px-4 py-3 sm:px-6 lg:px-8 flex flex-wrap justify-between items-center bg-white">
          {/* Mobile Menu Button */}
          <div className='md:hidden px-2 py-2 flex gap-3'>
            <button className="text-gray-700 text-lg" onClick={() => setShowMenu(!showMenu)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 20 20" stroke="none" style={{height: '20px', width: '20px'}}><g style={{ stroke: 'rgb(var(--brand-600))' }} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" clipPath="url(#icon_hamburger_svg__a)"><path d="M2.917 10.046h10.231M2.917 3.75h14.166M2.917 16.343h14.166"></path></g><defs><clipPath id="icon_hamburger_svg__a"><path fill="#fff" d="M0 0h20v20H0z"></path></clipPath></defs></svg>
            </button>
            <span
              className="text-gray-500 ml-0 md:ml-4 text-lg w-[60px] md:w-[165px] md:h-[25px] overflow-hidden"
              onClick={() => { window.location.href = process.env.PUBLIC_URL || '/'; }}
            >
              <img
                src={`${process.env.PUBLIC_URL || ''}/logo.png`}
                alt="Logo"
                className="w-full object-cover"
              />
            </span>
          </div>
          {/* Desktop Navbar */}
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <img
                onClick={() => { window.location.href = process.env.PUBLIC_URL || '/'; }}
                className="h-16 cursor-pointer hidden md:block"
                src={`${process.env.PUBLIC_URL || ''}/logo.png`}
                alt="Logo"
              />
            </div>
          </div>

          {/* Search Bar */}
          <HeaderSearchBar />

          <div className="flex gap-3 uppercase mr-4 text-gray-700">
              <Link to={'/myaccount/orders'} className="text-sm font-semibold">
              <GoPackageDependents />
              </Link>
          </div>

          {/* Icons for User, Wishlist, Cart */}
          <div className="flex items-center gap-6">
            <div className="hidden md:flex">
              {(userToken && (localStorage.getItem('uservarified') && localStorage.getItem('uservarified') !== "null")) ? (
                <div className="items-center gap-3">
                  <div className="relative font-bold text-gray-800 group">
                    <Link to={'/myaccount'} className="flex flex-col items-center gap-1 text-gray-700 hover:text-brand-600">
                      <FaUser className="text-base" />
                      <span className="text-[11px] font-medium normal-case">Account</span>
                    </Link>
                    <span className="hidden group-hover:block top-full left-0 border bg-white absolute p-2 z-20">
                      <Link className="text-black text-sm font-light text-nowrap" to={'/myaccount'}>My Account</Link>
                      <button onClick={logout} className="text-black text-sm font-light">Logout</button>
                    </span>
                  </div>
                </div>
              ) : (
                <Link className='flex flex-col items-center gap-1 text-gray-700 hover:text-brand-600 text-sm font-semibold' to="/login">
                  <FaUser className="text-base" />
                  <span className="text-[11px] font-medium normal-case">Account</span>
                </Link>
              )}
            </div>

            <Link to="/wishlist" className="relative flex flex-col items-center gap-1 text-gray-700 hover:text-brand-600">
              <FaRegHeart className='text-lg md:text-base' />
              <span className="hidden md:block text-[11px] font-medium normal-case">Wishlist</span>
              {wishlistCount > 0 && (
                <span className="absolute -top-1 right-0 md:right-2 transform translate-x-1/2 -translate-y-1/2 text-xs text-white bg-badge-orange rounded-full w-4 h-4 flex items-center justify-center">
                  {wishlistCount}
                </span>
              )}
            </Link>

            <Link to="/cart" className="relative flex flex-col items-center gap-1 text-gray-700 hover:text-brand-600">
              <FaBagShopping className='text-lg md:text-base' />
              <span className="hidden md:block text-[11px] font-medium normal-case">Cart</span>
              {cartLength > 0 && (
                <span className="absolute -top-1 right-0 md:right-2 transform translate-x-1/2 -translate-y-1/2 text-xs text-white bg-badge-orange rounded-full w-4 h-4 flex items-center justify-center">
                  {cartLength}
                </span>
              )}
            </Link>
          </div>
        </div>

        {/* Shop-by-category dropdown + primary nav links */}
        <div className="hidden md:flex items-center gap-8 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 border-t border-gray-100 bg-white">
          <div className="relative">
            <button
              type="button"
              onClick={() => setShowCategoryMenu((v) => !v)}
              className="flex items-center gap-2 bg-brand-600 hover:bg-brand-700 text-white text-xs font-semibold uppercase tracking-wide px-4 py-2 rounded-full transition-colors"
            >
              <FiMenu size={14} />
              Shop By Category
              <FiChevronDown size={14} />
            </button>
            {showCategoryMenu && (
              <>
                <div className="fixed inset-0 z-10" onClick={() => setShowCategoryMenu(false)} />
                <div className="absolute left-0 top-full mt-2 w-48 bg-white border border-gray-100 rounded-lg shadow-lg py-2 z-20">
                  {shopCategories.map((cat) => (
                    <Link
                      key={cat.to}
                      to={cat.to}
                      onClick={() => setShowCategoryMenu(false)}
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-brand-50 hover:text-brand-600"
                    >
                      {cat.label}
                    </Link>
                  ))}
                </div>
              </>
            )}
          </div>
          <nav className="flex-1 flex items-center justify-between text-sm font-bold text-gray-800">
            <Link to="/" className={navLinkClass('/')}>Home</Link>
            <Link to="/products" className={navLinkClass('/products')}>All Products</Link>
            <Link to="/bucket" className={navLinkClass('/bucket')}>Buckets</Link>
            <Link to="/planters" className={navLinkClass('/planters')}>Planters</Link>
            <Link to="/fridge-bottle" className={navLinkClass('/fridge-bottle')}>Fridge Bottles</Link>
            <Link to="/about-us" className={navLinkClass('/about-us')}>About</Link>
            <Link to="/contact-us" className={navLinkClass('/contact-us')}>Contact</Link>
          </nav>
        </div>
      </header>
      {/* Mobile Menu Items */}
      <div className="mobile_menu md:hidden">
            {showMenu && (
              <div className='bg-surface-dark/60 absolute top-0 left-0 z-[100] w-full h-screen' onClick={() => setShowMenu(false)}>
                <div className="menu_items relative overflow-y-scroll scrollbar-none bg-white" onClick={(e) => e.stopPropagation()}>
                  <button onClick={() => setShowMenu(false)} className='absolute right-4 top-4 text-gray-400 hover:text-gray-700 text-lg'>✕</button>

                  <div className="flex gap-5 flex-col px-5 py-6">
                    {userToken ? (
                      <div className='flex items-center gap-3'>
                        {localStorage.getItem('username') && (
                          <span className='text-lg font-semibold w-10 h-10 rounded-full bg-brand-600 text-white uppercase flex justify-center items-center shrink-0'>
                            {localStorage.getItem('username')?.charAt(0)}
                          </span>
                        )}
                        <span className="font-semibold text-gray-800">
                          Hey, <Link to={'/myaccount'} className="text-brand-600">{localStorage.getItem('username') || 'User'}</Link>
                        </span>
                      </div>
                    ) : (
                      <div className='flex items-center gap-3'>
                        <span className="w-10 h-10 rounded-full border border-gray-200 flex items-center justify-center shrink-0">
                          <UserRound size={18} className="text-gray-500" />
                        </span>
                        <Link to="/login">
                          <p className='text-xs text-gray-500'>Hey There!</p>
                          <p className='text-gray-900 font-bold text-sm'>LOGIN / SIGNUP</p>
                        </Link>
                      </div>
                    )}

                    <Link
                      to="/products"
                      onClick={() => setShowMenu(false)}
                      className="bg-brand-600 hover:bg-brand-700 text-white text-sm font-semibold text-center py-3 rounded-xl transition-colors"
                    >
                      All Products
                    </Link>

                    <div>
                      <p className='text-gray-400 text-[11px] font-bold uppercase tracking-wide mb-2'>Shop By Category</p>
                      <div className="grid grid-cols-2 gap-2">
                        {shopCategories.map((cat) => (
                          <Link
                            key={cat.to}
                            to={cat.to}
                            onClick={() => setShowMenu(false)}
                            className="text-sm text-gray-700 font-medium px-3 py-2.5 rounded-lg bg-gray-50 hover:bg-brand-50 hover:text-brand-600 transition-colors"
                          >
                            {cat.label}
                          </Link>
                        ))}
                      </div>
                    </div>

                    {userToken && (
                      <div>
                        <p className='text-gray-400 text-[11px] font-bold uppercase tracking-wide mb-2'>My Profile</p>
                        <div className='flex gap-3'>
                          <Link className='flex-1 flex gap-2 items-center flex-col' to={'/myaccount'} onClick={() => setShowMenu(false)}>
                            <User2Icon className='border border-gray-200 rounded-xl p-4 w-full h-16 text-gray-600' />
                            <span className='text-[11px] text-gray-600 font-medium'>My Account</span>
                          </Link>
                          <Link className='flex-1 flex gap-2 items-center flex-col' to={'/myaccount/orders'} onClick={() => setShowMenu(false)}>
                            <FaTruckFast className='border border-gray-200 rounded-xl p-4 w-full h-16 text-gray-600' />
                            <span className='text-[11px] text-gray-600 font-medium'>My Orders</span>
                          </Link>
                          <Link className='flex-1 flex gap-2 items-center flex-col' to={'/wishlist'} onClick={() => setShowMenu(false)}>
                            <Heart className='border border-gray-200 rounded-xl p-4 w-full h-16 text-gray-600' />
                            <span className='text-[11px] text-gray-600 font-medium'>Wishlist</span>
                          </Link>
                        </div>
                      </div>
                    )}

                    <div className="border-t border-gray-100 pt-4 flex flex-col gap-3">
                      <div>
                        <p className='text-gray-400 text-[11px] font-bold uppercase tracking-wide mb-1'>Contact Us</p>
                        <Link className='text-sm text-gray-700 hover:text-brand-600 font-medium' to={'/contact-us'} onClick={() => setShowMenu(false)}>Help & Support</Link>
                      </div>
                      <div>
                        <p className='text-gray-400 text-[11px] font-bold uppercase tracking-wide mb-1'>About Us</p>
                        <Link className='text-sm text-gray-700 hover:text-brand-600 font-medium' to={'/about-us'} onClick={() => setShowMenu(false)}>Our Story</Link>
                      </div>
                    </div>

                    {userToken && (
                      <button
                        onClick={logout}
                        className="text-red-600 font-semibold text-sm bg-red-50 hover:bg-red-100 p-3 rounded-xl flex items-center justify-center gap-2 transition-colors"
                      >
                        <BiExit /> Logout
                      </button>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
    </>
  );
};

export default NavTop;
